import React, { useEffect, useRef, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCalendarAlt,
  faBars,
  faUser,
  faSignOutAlt,
  faChevronDown,
} from "@fortawesome/free-solid-svg-icons";
import { useAuth } from '../context/AuthContext'
import NotificationBell from './NotificationBell'

export default function Header() {
    const { user, logout } = useAuth();
    const navigate = useNavigate();
    const [menuOpen, setMenuOpen] = useState(false);
    const menuRef = useRef(null);

    const isStudent = user?.role === 'client';
    const isAdmin = user?.role === 'admin';
    const displayName = (user?.name || user?.email || 'User').trim();
    const avatarUrl = `https://ui-avatars.com/api/?name=${encodeURIComponent(displayName)}&background=F47B20&color=fff`;

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (menuRef.current && !menuRef.current.contains(e.target)) {
                setMenuOpen(false);
            }
        };
        const handleEscape = (e) => {
            if (e.key === 'Escape') setMenuOpen(false);
        };
        document.addEventListener('mousedown', handleClickOutside);
        document.addEventListener('keydown', handleEscape);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('keydown', handleEscape);
        };
    }, []);

    const handleMenuToggle = () => {
        if (typeof window !== 'undefined' && window.innerWidth <= 992) {
            window.dispatchEvent(new CustomEvent('toggleMobileSidebar'));
        } else {
            window.dispatchEvent(new CustomEvent('toggleSidebar'));
        }
    };

    const handleLogout = () => {
        setMenuOpen(false);
        try {
            sessionStorage.setItem('logoutSuccess', '1');
        } catch {
            /* ignore storage errors */
        }
        logout();
        navigate('/');
    };

    return (
        <>
            <nav className="top-navbar justify-content-between">
                <div className="navbar-left">
                    <button
                        type="button"
                        className="toggle-sidebar-btn"
                        onClick={handleMenuToggle}
                        aria-label="Toggle navigation menu"
                        title="Menu"
                    >
                        <FontAwesomeIcon icon={faBars} />
                    </button>
                </div>

                <div className="navbar-right" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>

                    <NotificationBell />

                    {!isStudent && (
                    <Link
                        to="/meetings-calendar"
                        title="Meetings Calendar"
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: '38px',
                            height: '38px',
                            borderRadius: '10px',
                            background: 'linear-gradient(135deg, #F47B20, #e8660f)',
                            color: 'white',
                            textDecoration: 'none',
                            boxShadow: '0 3px 10px rgba(244,123,32,0.35)',
                            transition: 'transform 0.15s, box-shadow 0.15s',
                            flexShrink: 0,
                        }}
                        onMouseEnter={e => {
                            e.currentTarget.style.transform = 'scale(1.08)';
                            e.currentTarget.style.boxShadow = '0 5px 16px rgba(244,123,32,0.5)';
                        }}
                        onMouseLeave={e => {
                            e.currentTarget.style.transform = 'scale(1)';
                            e.currentTarget.style.boxShadow = '0 3px 10px rgba(244,123,32,0.35)';
                        }}
                    >
                        <FontAwesomeIcon icon={faCalendarAlt} style={{ fontSize: '16px' }} />
                    </Link>
                    )}

                    <div className="user-menu" ref={menuRef}>
                        <button
                            type="button"
                            className={`user-profile ${menuOpen ? 'open' : ''}`}
                            onClick={() => setMenuOpen((open) => !open)}
                            aria-haspopup="menu"
                            aria-expanded={menuOpen}
                        >
                            <img
                                src={avatarUrl}
                                alt={displayName}
                            />
                            <span>{displayName}</span>
                            <FontAwesomeIcon icon={faChevronDown} className="user-menu-chevron" />
                        </button>

                        {menuOpen && (
                            <div className="user-dropdown" role="menu">
                                {isAdmin && (
                                    <Link
                                        to="/my-profile"
                                        className="user-dropdown-item"
                                        role="menuitem"
                                        onClick={() => setMenuOpen(false)}
                                    >
                                        <FontAwesomeIcon icon={faUser} />
                                        My Profile
                                    </Link>
                                )}
                                <button
                                    type="button"
                                    className="user-dropdown-item danger"
                                    role="menuitem"
                                    onClick={handleLogout}
                                >
                                    <FontAwesomeIcon icon={faSignOutAlt} />
                                    Logout
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            </nav>
        </>
    )
}
